import React from 'react';
import { SwitchTemplate } from '@catalogo/core-switch-template';

export const Seller = props => <SwitchTemplate component="seller" {...props} />;

export default Seller;
